import React, { useEffect, useState } from "react";
import {
  getFirestore,
  collection,
  query,
  getDocs,
  limit,
  orderBy,
  startAfter,
  endBefore,
} from "firebase/firestore";
import { app } from "../firebase/firebase";

const db = getFirestore(app);

const ContactList = () => {
  const [contacts, setContacts] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [activeTab, setActiveTab] = useState("ContactMe");
  const [lastVisible, setLastVisible] = useState(null);
  const [firstVisible, setFirstVisible] = useState(null);
  const [totalPages, setTotalPages] = useState(1);
  const itemsPerPage = 3; // number of items per page

  const fetchTotalDocuments = async () => {
    const snapshot = await getDocs(collection(db, "contact"));
    setTotalPages(Math.ceil(snapshot.size / itemsPerPage));
  };

  const fetchContacts = async (direction) => {
    try {
      let q;

      if (direction === "next") {
        q = query(
          collection(db, "contact"),
          orderBy("createdAt", "desc"),
          startAfter(lastVisible),
          limit(itemsPerPage)
        );
        setCurrentPage((prev) => Math.min(prev + 1, totalPages));
      } else if (direction === "previous") {
        q = query(
          collection(db, "contact"),
          orderBy("createdAt", "desc"),
          endBefore(firstVisible),
          limit(itemsPerPage)
        );
        setCurrentPage((prev) => Math.max(prev - 1, 1));
      } else {
        q = query(
          collection(db, "contact"),
          orderBy("createdAt", "desc"),
          limit(itemsPerPage)
        );
      }

      const querySnapshot = await getDocs(q);
      if (!querySnapshot.empty) {
        setContacts(
          querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }))
        );
        setFirstVisible(querySnapshot.docs[0]);
        setLastVisible(querySnapshot.docs[querySnapshot.docs.length - 1]);
      }
    } catch (error) {
      console.error("Error fetching contacts:", error);
    }
  };

  useEffect(() => {
    fetchTotalDocuments();
    fetchContacts();
  }, []);

  return (
    <div className="container px-6 py-5">
      <h1 className="text-4xl font-semibold mt-14  text-blue-600 ">Contact List</h1>
      {/* Tab Navigation */}
      <div className="flex border-b   justify-end">
        <div className="flex items-center justify-center  space-x-4">
          <button
            onClick={() => fetchContacts("previous")}
            disabled={currentPage === 1}
            className={`px-4 py-2 rounded ${
              currentPage === 1
                ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                : "bg-customblue text-white hover:bg-blue-600"
            }`}
          >
            Previous
          </button>

          <span className="text-gray-700">
            Page {currentPage} of {totalPages}
          </span>

          <button
            onClick={() => fetchContacts("next")}
            disabled={currentPage >= totalPages}
            className={`px-4 py-2 rounded ${
              currentPage >= totalPages
                ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                : "bg-customblue text-white hover:bg-blue-600"
            }`}
          >
            Next
          </button>
        </div>
      </div>

      {/* Contact List Table */}

      <div>
        {contacts.length === 0 ? (
          <p className="text-gray-500 mt-6">No contacts available</p>
        ) : (
          <div>
            <table className="min-w-full bg-white border rounded-lg shadow-md">
              <thead className="bg-customblue">
                <tr>
                  <th className="text-left px-6 py-3 font-semibold text-white">
                    Name
                  </th>
                  <th className="text-left px-6 py-3 font-semibold text-white">
                    Email
                  </th>
                  <th className="text-left px-6 py-3 font-semibold text-white">
                    Message
                  </th>
                  <th className="text-left px-6 py-3 font-semibold text-white">
                    Date
                  </th>
                </tr>
              </thead>
              <tbody>
                {contacts.map((contact, index) => (
                  <tr
                    key={contact.id}
                    className={index % 2 === 0 ? "bg-gray-50" : "bg-white"}
                  >
                    <td className="px-6 py-3 text-gray-700">{contact.name}</td>
                    <td className="px-6 py-3 text-gray-700">{contact.email}</td>
                    <td className="px-6 py-3 text-gray-700">
                      {contact.message}
                    </td>
                    <td className="px-6 py-3 text-gray-700">
                      {new Date(contact.createdAt).toLocaleDateString()}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default ContactList;
